import i18next from 'i18next';

i18next.addResources('es_CL', 'InstallmentsSelector', {
  // eslint-disable-next-line camelcase
  installmentOptionDefault: 'Pago único',
  installmentOption: '{{count}} cuotas'
});
